import { Injectable } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  CloseMfaData,
  MfaActionsService,
  MfaContextType,
  MfaService,
  VerifyMfaCodeData,
} from "common";
import { MfaChangePhoneNumberService } from "./services/mfa-change-phone-number.service";

@UntilDestroy()
@Injectable()
export class MfaFacade {
  constructor(
    private mfaActions: MfaActionsService,
    private mfaService: MfaService,
    private mfaChangePhoneNumberService: MfaChangePhoneNumberService
  ) {}

  initActions(): void {
    this.mfaActions.verifyMfaCode$
      .pipe(untilDestroyed(this))
      .subscribe((data: VerifyMfaCodeData) => {
        this.verifyMfaCode(data);
      });

    this.mfaActions.close$
      .pipe(untilDestroyed(this))
      .subscribe((data: CloseMfaData) => {
        this.close(data);
      });
  }

  private verifyMfaCode(data: VerifyMfaCodeData) {
    switch (data.mfaData.contextType) {
      case MfaContextType.ChangePhoneNumber:
        return this.mfaChangePhoneNumberService.verify(data);
      default:
        this.mfaService.handleMfaError("Invalid mfaContextType to verify");
        break;
    }
  }

  private close(data: CloseMfaData) {
    switch (data.contextType) {
      case MfaContextType.ChangePhoneNumber:
        return this.mfaChangePhoneNumberService.close(data);
      default:
        this.mfaService.handleDefaultCloseAction();
        break;
    }
  }
}
